export const appMenuElements = [
  {
    key: 'vip',
    onSelect: 'navigate',
  },
  {
    key: 'diet',
    onSelect: 'openModal',
  },
  {
    key: 'profile',
    onSelect: 'openModal',
  },
  {
    key: 'languages',
    onSelect: 'openModal',
  },
  {
    key: 'openOrders',
    onSelect: 'openModal',
  },

  {
    key: 'orderHistory',
    onSelect: 'openModal',
  },
  {
    key: 'invoiceAddress',
    onSelect: 'openModal',
  },
  {
    key: 'coupons',
    onSelect: 'navigate',
  },
  {
    key: 'referal',
    onSelect: 'openModal',
  },
  {
    key: 'newsfeed',
    onSelect: 'navigate',
  },
  {
    key: 'lastOrder',
    onSelect: 'navigate',
  },
  {
    key: 'locations',
    onSelect: 'navigate',
  },
  {
    key: 'moreOrder',
    onSelect: 'navigate',
  },
  {
    key: 'mapLayouts',
    onSelect: 'navigate',
  },
  {
    onSelect: 'navigate',
    key: 'privacyLink',
  },

  {
    key: 'deliveryAddress',
    onSelect: 'openModal',
  },
  {
    key: 'customExternalLink',
    onSelect: 'navigate',
  },
];
